<aside class="sidebar" [class.sidebar--collapsed]="isCollapsed()">
  <!-- Brand -->
  <div class="sb-brand">
    <svg class="mark" viewBox="0 0 220 44" fill="none" aria-label="NODUM">
      <text x="0" y="34" fill="currentColor" font-family="Urbanist, Inter, system-ui" font-weight="800" font-size="36" letter-spacing="-1.4">N</text>
      <rect x="29" y="11" width="64" height="24" rx="12" stroke="currentColor" stroke-width="2.5" />
      <circle cx="81" cy="23" r="7.5" fill="var(--mint-ink)" />
      <text x="99" y="34" fill="currentColor" font-family="Urbanist, Inter, system-ui" font-weight="800" font-size="36" letter-spacing="-1.4">DUM</text>
    </svg>
    @if (!isCollapsed()) {
      <div class="sub">
        управління майном <span class="bar">|</span> <span class="on">увімкнено</span>
      </div>
    }
  </div>

  <!-- Collapse toggle -->
  <button
    type="button"
    class="sb-collapse"
    (click)="toggleSidebar()"
    [attr.aria-label]="isCollapsed() ? 'Розгорнути бічну панель' : 'Згорнути бічну панель'"
    [title]="isCollapsed() ? 'Розгорнути бічну панель' : 'Згорнути бічну панель'"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="15" height="15">
      @if (isCollapsed()) {
        <polyline points="9 18 15 12 9 6" />
      } @else {
        <polyline points="15 18 9 12 15 6" />
      }
    </svg>
  </button>

  <!-- Main navigation -->
  @for (item of mainNavItems(); track item.route) {
    <a
      class="sb-item"
      [routerLink]="item.route"
      routerLinkActive="active"
      [title]="isCollapsed() ? item.label : ''"
    >
      <ng-container [ngTemplateOutlet]="navIcon" [ngTemplateOutletContext]="{ $implicit: item.icon }" />
      @if (!isCollapsed()) {
        <span>{{ item.label }}</span>
      }
    </a>
  }

  <!-- Monitoring section -->
  @if (monitorNavItems().length) {
    @if (!isCollapsed()) {
      <div class="sb-section">Моніторинг</div>
    } @else {
      <div class="sb-section-rule" aria-hidden="true"></div>
    }
    @for (item of monitorNavItems(); track item.route) {
      <a
        class="sb-item"
        [routerLink]="item.route"
        routerLinkActive="active"
        [title]="isCollapsed() ? item.label : ''"
      >
        <ng-container [ngTemplateOutlet]="navIcon" [ngTemplateOutletContext]="{ $implicit: item.icon }" />
        @if (!isCollapsed()) {
          <span>{{ item.label }}</span>
        }
      </a>
    }
  }

  <!-- Account footer -->
  <div class="sb-foot-wrap" [class.open]="accountMenuOpen()">
    @if (accountMenuOpen()) {
      <div class="account-menu" role="menu">
        <div class="am-head">
          <div class="av">{{ userInitials() }}</div>
          <div class="am-id">
            <div class="who">{{ userName() }}</div>
            @if (orgName()) {
              <div class="org">{{ orgName() }}</div>
            }
          </div>
        </div>
        <div class="am-list">
          <a class="am-item" role="menuitem" routerLink="/profile" (click)="closeAccountMenu()">
            <span class="am-ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="17" height="17">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="8" r="4" />
              </svg>
            </span>
            <span class="am-text">
              <span class="am-label">Профіль</span>
              <span class="am-desc">Особисті дані та доступ</span>
            </span>
          </a>
          <button type="button" class="am-item" role="menuitem" (click)="closeAccountMenu()">
            <span class="am-ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="17" height="17">
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
            </span>
            <span class="am-text">
              <span class="am-label">Налаштування</span>
              <span class="am-desc">Сповіщення, вигляд, безпека</span>
            </span>
          </button>
          <button type="button" class="am-item" role="menuitem" (click)="closeAccountMenu()">
            <span class="am-ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="17" height="17">
                <circle cx="12" cy="12" r="9" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </span>
            <span class="am-text">
              <span class="am-label">Допомога</span>
              <span class="am-desc">Підтримка та документація</span>
            </span>
          </button>
        </div>
        <div class="am-sep"></div>
        <button type="button" class="am-item am-logout" role="menuitem" (click)="logout()">
          <span class="am-ic">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="17" height="17">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
          <span class="am-text"><span class="am-label">Вийти</span></span>
        </button>
      </div>
    }

    <button
      type="button"
      class="sb-foot"
      aria-haspopup="menu"
      [attr.aria-expanded]="accountMenuOpen()"
      [title]="isCollapsed() ? userName() : ''"
      (click)="toggleAccountMenu()"
    >
      <div class="av">{{ userInitials() }}</div>
      @if (!isCollapsed()) {
        <div class="sb-foot-id">
          <div class="who">{{ userName() }}</div>
          @if (orgName()) {
            <div class="org">{{ orgName() }}</div>
          }
        </div>
        <span class="sb-foot-caret">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="15" height="15">
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </span>
      }
    </button>
  </div>
</aside>

<!-- Outline nav icons (1.5 stroke), matching the v3 design system -->
<ng-template #navIcon let-icon>
  @switch (icon) {
    @case ('dashboard') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="7" height="9" rx="2" /><rect x="14" y="3" width="7" height="5" rx="2" />
        <rect x="14" y="12" width="7" height="9" rx="2" /><rect x="3" y="16" width="7" height="5" rx="2" />
      </svg>
    }
    @case ('building') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2" /><path d="M9 22v-5h6v5" />
        <path d="M9 7h.01M13 7h.01M9 11h.01M13 11h.01" />
      </svg>
    }
    @case ('user') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="8" r="4" />
      </svg>
    }
    @case ('home') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 10.5L12 3l9 7.5V20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M9 22v-7h6v7" />
      </svg>
    }
    @case ('land') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 8.5l9-4.5 9 4.5v7L12 20 3 15.5z" /><path d="M3 8.5L12 13l9-4.5" /><path d="M12 13v7" />
      </svg>
    }
    @case ('car') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 17h14M5 17v-4l2-5h10l2 5v4M5 17v2M19 17v2" />
        <circle cx="8" cy="17" r="1.4" /><circle cx="16" cy="17" r="1.4" />
      </svg>
    }
    @case ('reports') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <rect x="4" y="3" width="16" height="18" rx="2" /><line x1="9" y1="9" x2="15" y2="9" />
        <line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="13" y2="17" />
      </svg>
    }
    @case ('shield') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3l7 3v6c0 4.2-2.8 7.7-7 9-4.2-1.3-7-4.8-7-9V6z" /><path d="M9 12l2 2 4-4" />
      </svg>
    }
    @case ('key') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="8" cy="16" r="4.5" /><path d="M11.2 12.8L20 4" /><path d="M16.5 7.5l2.5 2.5" />
      </svg>
    }
    @case ('tasks') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 6.5l1.8 1.8L9 5" /><path d="M4 17.5l1.8 1.8L9 16" />
        <line x1="12" y1="7" x2="20" y2="7" /><line x1="12" y1="18" x2="20" y2="18" />
      </svg>
    }
    @case ('analytics') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="9" /><path d="M12 3a9 9 0 0 1 9 9h-9z" /><path d="M12 12L7 7" />
      </svg>
    }
    <!-- Будівля зі стрілкою вбік: юрособа, права якої переходять далі -->
    @case ('termination') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 21V5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v16" />
        <path d="M7 8h.01M10 8h.01M7 12h.01M10 12h.01" />
        <path d="M4 21h9" /><path d="M16 15h5" /><path d="M18.5 12.5 21 15l-2.5 2.5" />
      </svg>
    }
    @case ('heart') {
      <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20s-7-4.4-7-9.2A4 4 0 0 1 12 8a4 4 0 0 1 7 2.8C19 15.6 12 20 12 20z" />
      </svg>
    }
  }
</ng-template>
